import React from "react";
import PropTypes from "prop-types";

import WdSelect from "../../shared_components/wd_select";
import FormStrings from "../utils/form_strings";
import ViewAndFilterHelpers from "../utils/view_and_filter_helpers";

class SecondaryFilters extends React.Component {
  multi = true
  userSelectsSecondaryAreaFilterType = (e) => {
    let val = e ? e.value : null;
    this.props.userSelectsSecondaryAreaFilterType(val);

    this.props.onUpdate();
  }

  userSelectsSecondaryAreaOption = (e) => {
    this.props.userSelectsSecondaryAreaOption(e);

    this.props.onUpdate();
  }

  userSelectsSecondaryCategoryFilterType = (e) => {
    let val = e ? e.value : null;

    this.props.userSelectsSecondaryCategoryFilterType(val);

    this.props.onUpdate();
  }

  userSelectsSecondaryCategoryOption = (e) => {
    this.props.userSelectsSecondaryCategoryOption(e);

    this.props.onUpdate();
  }

  typesToSelectOptions(types, filterer, disabler) {
    return types.filter(filterer).map((e) => ({ value: e.id, label: e.secondary_filter_name, isDisabled: disabler(e) }));
  }

  render() {
    const p = this.props;
    const allOptionsDisabled = (opts) => (opts.filter((e) => !e.isDisabled).length === 0);

    const selectedViewType = ViewAndFilterHelpers.viewFromId(p.viewObjects, p.selectedViewTypeId);
    const selectedFilterType = ViewAndFilterHelpers.filterFromId(p.allFilterObjects, p.selectedPrimaryTypeId);

    const disable = (fo) => {
      if (selectedFilterType && selectedFilterType.disable_secondary_filters) return true;
      if (fo.id === p.selectedPrimaryTypeId) return true;
      if (!selectedViewType) return false;
      return !selectedViewType.allowed_secondary_filters.find((e) => e === fo.id);
    };

    const allow = (fo) => (fo.prevent_primary_or_secondary !== "secondary" && !(selectedFilterType && selectedFilterType.disable_secondary_filters));

    const secondaryFilterObjects = p.filterObjects.filter((e) => allow(e));
    const undisabledSecondaryFilterObjects = secondaryFilterObjects.filter((e) => !disable(e));

    // Area selects
    const areaFilter = (fo) => fo.geographic_type;
    const areaTypes = this.typesToSelectOptions(secondaryFilterObjects, areaFilter, disable)
                          .filter((type) => !type.isDisabled);
    const selectedAreaType = ViewAndFilterHelpers.filterFromId(undisabledSecondaryFilterObjects, p.areaTypeId);
    const areaTypeDisabled = allOptionsDisabled(areaTypes);

    const areaOptions = (selectedAreaType ? selectedAreaType.js_options : []).map((e) => ({ label: e, value: e }));
    const areaOptionDisabled = areaOptions.length === 0;

    // Category selects
    const categoryFilter = (fo) => !fo.geographic_type;
    const categoryTypes = this.typesToSelectOptions(secondaryFilterObjects, categoryFilter, disable)
                              .filter((type) => !type.isDisabled);
    const selectedCategoryType = ViewAndFilterHelpers.filterFromId(undisabledSecondaryFilterObjects, p.categoryTypeId);
    const categoryTypeDisabled = allOptionsDisabled(categoryTypes);

    const categoryOptions = (selectedCategoryType ? selectedCategoryType.js_options : []).map((e) => ({ label: e, value: e }));
    const categoryOptionDisabled = categoryOptions.length === 0;

    var geographicalAreaFilter;
    if (areaTypeDisabled && areaOptionDisabled) {
      geographicalAreaFilter = "";
    } else {
      const areaTypeDisplay = areaTypeDisabled ? "none" : "block";
      const areaOptionDisplay = areaOptionDisabled ? "none" : "block";
      geographicalAreaFilter = (
        <div>
          <h4>Additional geographical area filter</h4>
          <WdSelect
            value={areaTypes.find(t => t.value === p.areaTypeId) || null}
            name={FormStrings.secondaryAreaFilterTypeName}
            options={areaTypes}
            onChange={this.userSelectsSecondaryAreaFilterType}
            isClearable={true}
            isDisabled={areaTypeDisabled}
            style={{ "display": areaTypeDisplay }}
            />
          <WdSelect
            // `|| null`: when the reducer resets secondaryFilters (forecast/view switch)
            // this prop is undefined, and react-select v5 treats an undefined `value` as
            // UNCONTROLLED — it keeps its internal chips (and their hidden form inputs,
            // which then poison the next search into "no results"). v1 cleared on every
            // render; null restores that.
            value={p.areaOption || null}
            name={FormStrings.secondaryAreaFilterOptionName(this.multi)}
            options={areaOptions}
            onChange={this.userSelectsSecondaryAreaOption}
            isClearable={true}
            isDisabled={areaOptionDisabled}
            style={{ "display": areaOptionDisplay }}
            isMulti={this.multi}
            />
        </div>
      );
    }

    var spendingCategoryFilter;
    if (categoryTypeDisabled && categoryOptionDisabled) {
      spendingCategoryFilter = "";
    } else {
      const categoryTypeDisplay = categoryTypeDisabled ? "none" : "block";
      const categoryOptionDisplay = categoryOptionDisabled ? "none" : "block";
      spendingCategoryFilter = (
        <div>
          <h4>Additional spending category filter</h4>
          <WdSelect
            value={categoryTypes.find(t => t.value === p.categoryTypeId) || null}
            name={FormStrings.secondaryCategoryFilterTypeName}
            options={categoryTypes}
            onChange={this.userSelectsSecondaryCategoryFilterType}
            isClearable={true}
            isDisabled={categoryTypeDisabled}
            style={{ "display": categoryTypeDisplay }}
            />
          <WdSelect
            // `|| null` — same v5 undefined-is-uncontrolled trap as areaOption above.
            value={p.categoryOption || null}
            name={FormStrings.secondaryCategoryFilterOptionName(this.multi)}
            options={categoryOptions}
            onChange={this.userSelectsSecondaryCategoryOption}
            isClearable={true}
            isDisabled={categoryOptionDisabled}
            style={{ "display": categoryOptionDisplay }}
            isMulti={this.multi}
            />
        </div>
      );
    }

    return (
      <div>
        {geographicalAreaFilter}

        {spendingCategoryFilter}
      </div>
    );
  }
}

SecondaryFilters.propTypes = {
  viewObjects: PropTypes.arrayOf(PropTypes.object),
  filterObjects: PropTypes.arrayOf(PropTypes.object),
  selectedPrimaryTypeId: PropTypes.string,
  selectedViewTypeId: PropTypes.number,
  areaTypeId: PropTypes.string,
  areaOption: PropTypes.arrayOf(PropTypes.object),
  categoryTypeId: PropTypes.string,
  categoryOption: PropTypes.arrayOf(PropTypes.object),
  userSelectsSecondaryAreaFilterType: PropTypes.func.isRequired,
  userSelectsSecondaryAreaOption: PropTypes.func.isRequired,
  userSelectsSecondaryCategoryFilterType: PropTypes.func.isRequired,
  userSelectsSecondaryCategoryOption: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default SecondaryFilters;
